
import { LinearProgress, Button, Dialog, TextField, DialogTitle, DialogContent, DialogContentText, DialogActions, CircularProgress } from '@material-ui/core'
import React, { useRef, useState, useEffect } from 'react'
// import { TextField, Select, MenuItem, FormControl, InputLabel, ListSubheader, FormHelperText } from '@material-ui/core'

import { useHistory, useParams } from 'react-router-dom'
import { useSelector, useDispatch } from 'react-redux'
import axios from 'axios'
import cert from '../mem_cert.jpg'
import welen from '../letter_en.jpg'
import welhi from '../letter_hi.jpg'
import idcard from '../Member_ID_Card.jpg' //Imported by Jyoti for ID Card on 29th Oct., 2021
import studentId from '../Student_Member_ID_Card.jpg'
import stwelen from '../student_wel_en.jpg'
import stwelhi from '../student_wel_hi.jpg'
import studentCert from '../Student_cert.jpg'
import "../styles/AdminApplicationsView.css"
import { myBucket } from '../services/UploadService'
import { ApiURL } from '../constants/ApiUrl'
import { findLastKey } from 'lodash'
// import {useSelector, useDispatch} from 'react-redux'; // 21 oct 

function AdminStudentsView() {
    const [TempCour, setTempCour] = useState("")
    const [TempIssuDate, setTempIssuDate] = useState("")
    const [nameE, setnameE] = useState("")
    const [phoneE, setphoneE] = useState('')
    const [profileE, setProfileE] = useState("")
    const [signatureE, setsignatureE] = useState("")
    const [secEmailError, setsecEmailError] = useState("")
    const [RefMemN, setRefMemN] = useState("")
    const [error, setError] = useState(false)
    const [IsOpen7, setIsOpen7] = useState(false)
    const [sign, setsign] = useState(false)
    const [sign1, setsign1] = useState(false)
    const [certs, setcerts] = useState(false)
    const [secphoneE, setsecphoneE] = useState("")
    const [RefnameE, setRefnameE] = useState("")
    const [medError, setmedError] = useState("")
    const [RegE, setRegE] = useState('')
    const [emailError, setEmailError] = useState("")
    const [Progress1, setProgress1] = useState(0)
    const [Progress2, setProgress2] = useState(0)
    const [Progress3, setProgress3] = useState(0)
    const [Editable, setEditable] = useState(false)
    const FData = useSelector(state => state.FormDataReducer)
    const [TempDetails, setTempDetails] = useState({})
    const [TempCList, setTempCList] = useState([])
    const [nmoLists, setNmoLists] = useState([])
    const [nmoPrant, setNmoPrant] = useState([])
    const [Tp, setTp] = useState(0)
    const [Tp1, setTp1] = useState(10)
    const canvas0 = useRef();
    const image0 = useRef();
    const canvas7 = useRef();
    const [TempStWelHi, setTempStWelHi] = useState('')
    const [TempStwelEn, setTempStwelEn] = useState('')
    // const [allDetials, setDetials] = useState(0)


    const LoginReducer = useSelector(state => state.LoginReducer)
    var loginRes;
    if (LoginReducer.user !== undefined) {
        loginRes = LoginReducer.user.role
        // console.log(loginRes, "rolll")
    }
    // console.log(loginRes, "unn")

    const FormDetails = useSelector(state => state.AdminReducer.selectedApp);



    const canvas = useRef();
    const canvas4 = useRef();
    const canvas5 = useRef();

    const canvas3 = useRef();
    const image3 = useRef();
    const image4 = useRef();
    const image5 = useRef();
    const image6 = useRef();
    const image7 = useRef();


    // const image4 = useRef();

    const image = useRef();
    const canvas1 = useRef();
    const image1 = useRef();
    const canvas2 = useRef();
    const image2 = useRef();
    const [Open, setOpen] = useState(false)

    const [Open1, setOpen1] = useState(false)
    const [Open2, setOpen2] = useState(false)

    const [TempImg, setTempImg] = useState('')
    const [TempImg2, setTempImg2] = useState('')

    // console.log(TempImg, "imageeee")
    const [TempName, setTempName] = useState('')
    const [TempQul, setTempQul] = useState('')


    const [TempReason, setTempReason] = useState('')
    // const [FileTemp, setFileTemp] = useState({"wel_en": '', "wel_hi": '', "mem_cert_image": ''})
    const [TempCert, setTempCert] = useState('')
    const [TempCerts, setTempCerts] = useState('')

    const [TempWelEn, setTempWelEn] = useState('')
    const [TempWelHi, setTempWelHi] = useState('')
    const [TempIdCard, setTempIdCard] = useState('')//Created by Jyoti for ID Card on 29th Oct., 2021
    const [TempIdCards, setTempIdCards] = useState('')//Created by Jyoti for ID Card on 29th Oct., 2021

    const [MemNo, setMemNo] = useState(0)
    const [UploadCount, setUploadCount] = useState(0)
    const [IsOpen1, setIsOpen1] = useState(false)
    const [IsOpen2, setIsOpen2] = useState(false)
    const [IsOpen3, setIsOpen3] = useState(false)
    const [IsOpen4, setIsOpen4] = useState(false)
    const [IsOpen5, setIsOpen5] = useState(false)
    const [IsOpen6, setIsOpen6] = useState(false)
    const gender = ["Male", "Female", "Other"]
    const bloodGroup = ["A+", "A-", "B+", "B-", "AB+", "AB-", "O+", "O-"]
    // const [error, setError] = useState(false)
    // const [sign,setsign]=useState(false)
    // const [certs,setcerts]=useState(false)

    const [stateList, setStateList] = useState([])
    const [SName, setSName] = useState("")
    const [CName, setCName] = useState('');
    const [collagelist, setCollagelist] = useState([])
    const [isTrue, setIsTrue] = useState(true)


    const [isSubmitting, setisSubmitting] = useState(false)
    const [Type, setType] = useState('')
    // console.log(!FormDetails.isVerified)


    const history = useHistory();
    const dispatch = useDispatch();
    const { id } = useParams();
    const [isLoadingMember, setIsLoadingMember] = useState(
        !FormDetails._id || (id && FormDetails._id !== id)
    );

    useEffect(() => {
        const loadMember = async () => {
            if (!id) {
                history.replace('/admin/members');
                return;
            }
            if (FormDetails._id === id) {
                setIsLoadingMember(false);
                return;
            }
            try {
                const result = await axios.get(`${ApiURL}/api/get_applications/${id}`);
                const data = result.data.data;
                if (data.appType !== 'student') {
                    history.replace(`/admin/members/${id}`);
                    return;
                }
                dispatch({ type: 'SELECTED_APPLICATION', payload: data });
            } catch (error) {
                console.error(error);
                history.replace('/admin/members');
            } finally {
                setIsLoadingMember(false);
            }
        };
        loadMember();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [id]);

    // console.log(FormDetails.payment.success, FormDetails)

    useEffect(() => {
        if (!FormDetails._id || !FormDetails.memberOn) return;
        const dd = (new Date(FormDetails.memberOn).getDate() + '/' + (new Date(FormDetails.memberOn).getMonth() + 1) + '/' + new Date(FormDetails.memberOn).getFullYear());
        setTempIssuDate(dd)
        console.log(TempIssuDate.length, "length")
        a()
    }, [FormDetails._id, FormDetails.memberOn])

    useEffect(() => {
        console.log(TempCerts, "certtt")
        // collegeChanged(FormDetails.college)
        if (TempStWelHi !== '' && TempStwelEn !== '') {
            if (FormDetails.appType === 'student') {
                setTimeout(async () => {
                    const res = await axios.post(`${ApiURL}/send_new_generate_mail`, {
                        "mem_no": FormDetails.mem_no,
                        "certificate_Img": TempCerts,
                        "idcard": TempIdCards,
                    })
                    alert(res.data)
                    history.replace('/admin/members')
                  
                   
                    setisSubmitting(false)
                }, 1000);
            }
        }
        // eslint-disable-next-line
    }, [UploadCount, TempCerts, TempIdCards, TempStwelEn, TempStWelHi])


    const handleClose = () => {
        setOpen(false);
        setOpen1(false);
        setIsOpen6(false)
    }

    const handleTempName = (e) => {
        setTempName(e.target.value);


    }
    const handleTempQul = (e) => {
        setTempQul(e.target.value);
    }
    const handleTempIssuDate = (e) => {
        setTempIssuDate(e.target.value)
    }
    const handleTempCour = (e) => {
        setTempCour(e.target.value);


    }
    const handleTempReason = (e) => {
        setTempReason(e.target.value);
    }

    const handleApprove = () => {
        const dd = (new Date(FormDetails.memberOn).getDate() + '/' + (new Date(FormDetails.memberOn).getMonth() + 1) + '/' + new Date(FormDetails.memberOn).getFullYear());
        setTempIssuDate(dd)
        setMemNo(FormDetails.mem_no)
        generateWelCertEn(MemNo.toString(), FormDetails.name);
        generateWelCertHi(MemNo.toString(), FormDetails.name);
        var resi1 = `${FormDetails.address.line1} , ${FormDetails.address.line2}`
        var resi2 = `${FormDetails.address.city} , ${FormDetails.address.state} , ${FormDetails.address.pincode}`
        generateCert(MemNo.toString(), FormDetails.name, FormDetails.qualifications, FormDetails.college, FormDetails.nmo_unit, FormDetails.email, FormDetails.blood_group, resi1, resi2, FormDetails.phone, FormDetails.profile_image, FormDetails.signature_image, false);
        setTempName(FormDetails.name);
        setTempQul(FormDetails.qualifications)
        setTempCour(FormDetails.college)
        setOpen(true);
    }

    const handleReject = () => {
        setOpen1(true);
    }
    const handlever = () => {
        setOpen2(true);
    }


    const handleFinalApproval = () => {

        setIsOpen1(true);
    }
    const handleopen = () => {
        setIsOpen7(true)
    }
    const handleFinalReject = () => {
        setIsOpen2(true);
    }

    const handleSubApp = () => {
        setisSubmitting(true);
        var resi1 = `${FormDetails.address.line1} , ${FormDetails.address.line2}`
        var resi2 = `${FormDetails.address.city} , ${FormDetails.address.state} , ${FormDetails.address.pincode}`

        // generateCert(FormDetails.mem_no.toString(), TempName, TempQul, FormDetails.college, FormDetails.nmo_unit, FormDetails.email, FormDetails.blood_group, resi1, resi2, FormDetails.phone, FormDetails.profile_image, FormDetails.signature_image, true);
        // uploadFile(`wel_en_${FormDetails._id}.jpg`, canvas1, setTempWelEn)
        // uploadFile(`wel_hi_${FormDetails._id}.jpg`, canvas2, setTempWelHi)

        // uploadFile(`member_IdCard_${FormDetails._id}.jpeg`, canvas5, setTempIdCards)
        // uploadFile(`member_cert_${FormDetails._id}.jpg`, canvas4, setTempCerts)
        generateCert(FormDetails.mem_no.toString(), TempName, TempQul, TempCour, FormDetails.nmo_unit, FormDetails.email, FormDetails.blood_group, resi1, resi2, FormDetails.phone, FormDetails.profile_image, FormDetails.signature_image, true);
        uploadFile(`member_IdCard_${FormDetails._id}.jpeg`, canvas5, setTempIdCards)
        uploadFile(`member_cert_${FormDetails._id}.jpg`, canvas4, setTempCerts)
        uploadFile(`wel_en_${FormDetails._id}.jpg`, canvas0, setTempStwelEn)
        uploadFile(`wel_hi_${FormDetails._id}.jpg`, canvas7, setTempStWelHi)
        setIsOpen1(false);
        setIsOpen7(false)
    }



    const handleNoApp = () => {
        setOpen2(false)                // 20 oct jyoti add this function for reject
        setIsOpen1(false);
        setIsOpen2(false);
        setIsOpen3(false);
        setIsOpen5(false);
        setIsOpen6(false)

    }


function uploadFile(name, canv, setVal) {
  canv.current.toBlob(async function (blob) {
    if (!blob) return;

    try {
      const key = `applications/${FormDetails.appType}/${FormDetails.mem_no}/${name}`;

      // 1️⃣ Get signed URL from backend
      const res = await axios.get(
        `${ApiURL}/api/upload/signed-url?key=${encodeURIComponent(key)}&contentType=${encodeURIComponent(blob.type)}`
      );
      const { url } = res.data;
      console.log("Signed URL generated:", url);

      // 2️⃣ Upload with progress tracking
      await new Promise((resolve, reject) => {
        const xhr = new XMLHttpRequest();
        xhr.open("PUT", url);
        xhr.setRequestHeader("Content-Type", blob.type);

        xhr.upload.onprogress = (event) => {
          if (event.lengthComputable) {
            const percent = Math.round((event.loaded / event.total) * 100);
            setProgress1(percent); // Update progress
          }
        };

        xhr.onload = () => {
          if (xhr.status === 200) resolve(xhr.response);
          else reject(new Error(`Upload failed with status ${xhr.status}`));
        };
        xhr.onerror = () => reject(new Error("Network error during upload"));

        xhr.send(blob);
      });

      // 3️⃣ Update state with R2 public URL
      setUploadCount(UploadCount + 1);
      setVal(`https://pub-5e98b3129b274a77aa3ee9286a182644.r2.dev/${key}`);
      console.log("File uploaded successfully:", key);

      // Reset progress
      setProgress1(0);

    } catch (err) {
      console.error("Upload error:", err);
    }
  }, "image/jpeg");
}


    function generateWelCertHi(mem_no, doc_name) {
        const can = canvas7;
        const ctx = can.current.getContext("2d");
        const img = image7.current;
        ctx.drawImage(img, 0, 0);
        // console.log(FileTemp);
        const dd = new Date();
        ctx.font = "50px serif";
        ctx.fillText(mem_no, 1680, 1330)
        ctx.fillText(dd.getDate() + '/' + (dd.getMonth() + 1) + '/' + dd.getFullYear(), 2130, 1140)
        ctx.fillText(doc_name, 320, 1210);

    }
    function generateWelCertEn(mem_no, doc_name) {
        const can = canvas0;
        const ctx = can.current.getContext("2d");
        const img = image0.current;
        ctx.drawImage(img, 0, 0);
        // console.log(FileTemp);
        const dd = new Date();
        ctx.font = "25px serif";
        ctx.fillText(mem_no, 900, 700)
        ctx.fillText(dd.getDate() + '/' + (dd.getMonth() + 1) + '/' + dd.getFullYear(), 950, 580)
        ctx.fillText(doc_name, 240, 630);

    }

    function generateCert(mem_no, doc_name, qualification, college, nmo_unit, email, mobile_no, blood_group, address1, address2, profile_img, signature_img, upload) {
        if (FormDetails.appType !== 'student') {
            var can = canvas;
            const ctx = can.current.getContext("2d");
            const img = image.current;
            ctx.drawImage(img, 0, 0)
            ctx.font = "40px serif";
            ctx.fillText(FormDetails.mem_no, 650, 227);
            const dd = (TempIssuDate);
            ctx.fillText(dd, 1050, 230);
            ctx.font = "40px serif";
            ctx.fillStyle = "#2D308F";
            ctx.fillText(doc_name, 800, 440);
            setTempImg(can.current.toDataURL("image/jpeg"))
            const can_id = canvas3;
            const ctx_id = can_id.current.getContext("2d");
            const img_id = image3.current;
            ctx_id.drawImage(img_id, 0, 0)
            ctx_id.font = "25px serif";
            ctx_id.fillStyle = "#2D308F";
            ctx_id.fillText(FormDetails.mem_no, 390, 195);
            ctx_id.font = "23px serif";
            ctx_id.fillStyle = "#2D308F";
            ctx_id.fillText(doc_name, 345, 250);
            ctx_id.font = "23px serif";
            ctx_id.fillText(qualification, 345, 300)
            ctx_id.font = "25px serif";
            ctx_id.fillText(nmo_unit, 345, 355)
            const date = new Date(TempIssuDate);
            ctx_id.fillText(date.getFullYear(), 335, 435);
            ctx_id.font = "25px serif";
            ctx_id.fillText(FormDetails.phone, 200, 540)
            ctx_id.fillText(FormDetails.email, 200, 575)
            ctx_id.fillText(FormDetails.blood_group, 210, 610)
            ctx_id.font = "20px serif";
            ctx_id.fillText(FormDetails.address.line1, 200, 645)
            ctx_id.fillText(FormDetails.address.city, 200, 675)
            setTempIdCard(can_id.current.toDataURL("image/jpeg"))
        } else {
            var can = canvas4;
            const ctx = can.current.getContext("2d");
            const img = image4.current;
            ctx.drawImage(img, 0, 0)
            ctx.font = "40px serif";
            ctx.fillStyle = "#2D308F";
            ctx.fillText(FormDetails.mem_no, 650, 230);
            const dd = (TempIssuDate);
            ctx.fillText(dd, 1050, 230);
            ctx.font = "40px serif";
            ctx.fillText(doc_name, 800, 400)
            setTempImg2(can.current.toDataURL("image/jpeg"))
            const can_id = canvas5;
            const ctx_id = can_id.current.getContext("2d");
            const img_id = image5.current;
            ctx_id.drawImage(img_id, 0, 0)
            ctx_id.font = "20px serif";
            ctx_id.fillStyle = "#2D308F";
            ctx_id.fillText(FormDetails.mem_no, 335, 190);
            ctx_id.font = "23px serif";
            ctx_id.fillText(doc_name, 335, 245);
            ctx_id.font = "23px serif";
            ctx_id.fillText(qualification, 335, 282)
            ctx_id.fillText(college, 335, 317)
            ctx_id.font = "25px serif";
            ctx_id.fillText(nmo_unit, 335, 353)
            if (TempIssuDate.length === 10) {
                const date = TempIssuDate.slice(6, 10);
                ctx_id.fillText(date, 330, 430);
            }
            else if (TempIssuDate.length === 9) {
                const date = TempIssuDate.slice(5, 10);
                ctx_id.fillText(date, 330, 430);
            } else {
                const date = TempIssuDate.slice(4, 10);
                ctx_id.fillText(date, 330, 430);
            }
            ctx_id.fillText(FormDetails.phone, 185, 545)
            ctx_id.fillText(FormDetails.email, 185, 580)
            ctx_id.fillText(FormDetails.blood_group, 185, 615)
            ctx_id.font = "20px serif";
            ctx_id.fillText(FormDetails.address.city, 185, 645)
            ctx_id.fillText(FormDetails.address.city, 180, 675)
            setTempIdCards(can_id.current.toDataURL("image/jpeg"))
        }
    }

    var s = []
    const a = async () => {
        const result = await axios.get(`${ApiURL}/api/get_states`);
        result.data.forEach(element => {
            s.push(element.state_name)
        });
        setStateList(s)
    }
    const collegeChanged = (e) => {
        
        if (e == 'other') {
            setIsTrue(false)

        }
        setTempDetails({ ...TempDetails, ["college"]: e });
        setCName(e)
        console.log(e, 'value of input')
    }
    const stateChanged = async (e) => {
        setTempDetails({ ...TempDetails, [e.target.name]: e.target.value });
        setSName(e.target.value)
        const result = await axios.post(`${ApiURL}/api/get_medical_college`, {            // addinng API for getting prant
            "state": e.target.value
        });
        const college_list = result.data.medical_college
        college_list.forEach(element => {
            s.push(element)
        });

        setCollagelist(s)
    }
    const handleverify = () => {
        generateWelCertEn(MemNo.toString(), FormDetails.name);
        generateWelCertHi(MemNo.toString(), FormDetails.name);
        var resi1 = `${FormDetails.address.line1} , ${FormDetails.address.line2}`
        var resi2 = `${FormDetails.address.city} , ${FormDetails.address.state} , ${FormDetails.address.pincode}`
        generateCert(FormDetails.mem_no.toString(), FormDetails.name, FormDetails.qualifications, FormDetails.college, FormDetails.nmo_unit, FormDetails.phone, FormDetails.email, FormDetails.blood_group, resi1, resi2, FormDetails.profile_image, FormDetails.signature_image, false);
        setTempName(FormDetails.name);
        setTempQul(FormDetails.qualifications)
        setTempCour(FormDetails.college)
        setIsOpen6(true)
    }
    var s = []
    const handleEdit = async () => {
        const result_prant = await axios.post(`${ApiURL}/api/get_prant_list`, {
            "state_name": FormDetails.nmo_state
        })
        setProgress2(0)
        setProgress1(0)
        setNmoPrant(result_prant.data.prant_name)
        if (Editable) {
            setEditable(false);
        } else {
            const result = await axios.get(`${ApiURL}/api/get_states`);

            result.data.forEach(element => {

                s.push(element.state_name)
                // }
            });
            setNmoLists(s)
            if (FData.qual.length === 0) {

                const result = await axios.get(`${ApiURL}/constants/all`);
                dispatch({ type: "SET_STATES", payload: result.data.state });
                dispatch({ type: "SET_NMOSTATES", payload: result.data.nmostate });
                dispatch({ type: "SET_QUAL", payload: result.data.qual });
            }
            collegeChanged(FormDetails.college)
            setTempDetails(FormDetails);
            setEditable(true);
            FData.states.forEach((item) => {
                if (item.state === FormDetails.address.state) {
                    setTempCList(item.districts)
                }
            })
        }
    }
    const handleUpdate = async () => {
        const result = await axios.post(`${ApiURL}/api/update_app`, TempDetails);
        if (result.status === 200) {
            const all_update = JSON.parse(result.config.data)
            const NumberRef = Number(all_update.ref_membership_no)
            // setMemNo(all_update.mem_no)
            if (all_update.email === '') {
                setEmailError("Email Id is Required")
                setnameE("")
                alert("Email Id is Required")
            }
            else if (!all_update.email.includes('@') || !all_update.email.includes(all_update.email.toLowerCase())) {
                setEmailError("Inavlid Email")
                alert("Inavlid Email")
                setnameE("")
            }
            else if (all_update.name === '') {
                setnameE("Name is Required")
                alert("Name is Required")
                setEmailError("")
            }
            else if (all_update.phone == '') {
                setphoneE("Number is Required")
                alert("Number is Required")
                setEmailError("")
                setnameE("")
            }

            else if (all_update.phone.length < 10) {
                setEmailError("")
                setphoneE("invalid Number")
                alert('invalid Number')
                setnameE("")
            }
            else if (all_update.profile_image === '') {
                setEmailError("")
                setProfileE("profile image is Required")
                alert("profile image is Required")
                setnameE("")
            }


            else if (all_update.signature_image === '') {
                setEmailError("")
                setsignatureE("sigature image is Required")
                alert("sigature image is Required")
                setnameE("")
            }
            else if (all_update.cert_image === '') {
                setEmailError("")
                setmedError("Medical Licence  is Required")
                alert("Medical Licence  is Required")
                setnameE("")
            }
            else if (all_update.ref_membership_no == '') {
                setEmailError("")
                setRefMemN("Ref Membership Number is Required")
                alert("Ref Membership Number is Required")
                setnameE("")
            }
            else if (all_update.ref_person_phone == '') {
                setsecphoneE("Number is Required")
                alert("Number is Required")
                setEmailError("")
                setnameE("")
            }
            else if (typeof (Number(all_update.regno)) !== 'number') {
                setRegE('Reg Number should be Number')
                alert('Reg Number should be Number')
            }
            else if (all_update.phone.length < 9) {
                setEmailError("")
                setsecphoneE("invalid Number")
                alert("invalid Number")
                setnameE("")
            }
            else if (typeof (NumberRef) !== 'number') {
                setRefMemN("Ref Membership Number should be Number")
                alert("Ref Membership Number should be Number")
                setEmailError("")
                setnameE("")
            }
            else if (all_update.ref_person === '') {
                setRefnameE("Name is Required")
                alert("Name is Required")
                setEmailError("")
            }
            else if (all_update.state_sec_email === '') {
                alert("Secretary Email Id is Required")
                setsecEmailError("Secretary Email Id is Required")
                setEmailError("")
                setnameE("")
            }
            else if (!all_update.state_sec_email.includes('@') || !all_update.state_sec_email.includes(all_update.state_sec_email.toLowerCase())) {
                setsecEmailError("Inavlid Email")
                alert("Inavlid Email")
                setEmailError("")
                setnameE("")
            }
            else {
                alert("Record Updated");
                setTp(Tp + 1);
                setTp1(Tp1 + 1);
                dispatch({ type: "SELECTED_APPLICATION", payload: TempDetails });
                // console.log(TempDetails, "gfffff")
                setEditable(false);
            }

        }
    }
    const handleChange = (e) => {
        setTempDetails({ ...TempDetails, [e.target.name]: e.target.value });
    }
    const handleAddChange = (e) => {
        if (e.target.name === 'state') {
            FData.states.map((item) => {
                if (item.state === e.target.value) {
                    setTempCList(item.districts)
                }
                return true;
            })
        }
        setTempDetails({ ...TempDetails, address: { ...TempDetails.address, [e.target.name]: e.target.value } })
    }
    const handelNmoState = async (e) => {

        setTempDetails({ ...TempDetails, [e.target.name]: e.target.value });
        const result = await axios.post(`${ApiURL}/api/get_prant`, {
            "state": e.target.value
        });

        setNmoPrant(result.data.prant_name)


    }
    const handelNmoPrant = async (e) => {
        setTempDetails({ ...TempDetails, [e.target.name]: e.target.value });

    }
const handleFileChange = async (e) => {
  try {
    const file = e.target.files[0];
    if (!file) return;

    const ext = file.name.split('.').pop().toLowerCase();
    if (!["jpg", "jpeg", "bmp", "png"].includes(ext)) {
      alert("Only JPG, BMP, PNG files allowed");
      return;
    }

    const key = `applications/${FormDetails.appType}/${FormDetails.mem_no}/profile_image.${ext}`;
    setsign(true);

    // 1️⃣ Get signed URL
    const res = await axios.get(
      `${ApiURL}/api/upload/signed-url?key=${encodeURIComponent(key)}&contentType=${encodeURIComponent(file.type)}`
    );
    const { url } = res.data;

    // 2️⃣ Upload with progress tracking
    await new Promise((resolve, reject) => {
      const xhr = new XMLHttpRequest();
      xhr.open("PUT", url);
      xhr.setRequestHeader("Content-Type", file.type);

      xhr.upload.onprogress = (event) => {
        if (event.lengthComputable) {
          setProgress1(Math.round((event.loaded / event.total) * 100));
        }
      };

      xhr.onload = () => (xhr.status === 200 ? resolve() : reject(new Error(`Upload failed with status ${xhr.status}`)));
      xhr.onerror = () => reject(new Error("Network error during upload"));

      xhr.send(file);
    });

    // 3️⃣ Update state
    setTempDetails({
      ...TempDetails,
      [e.target.name]: `https://pub-5e98b3129b274a77aa3ee9286a182644.r2.dev/${key}`
    });
    setProgress1(0);
    console.log("Profile image uploaded:", key);
  } catch (err) {
    console.error("Upload error (profile):", err);
  }
};

const handleIdChange = async (e) => {
  try {
    const file = e.target.files[0];
    if (!file) return;

    const ext = file.name.split('.').pop().toLowerCase();
    if (!["jpg", "jpeg", "bmp", "png", "pdf"].includes(ext)) {
      alert("Only JPG, BMP, PNG & PDF files allowed");
      return;
    }

    const key = `applications/${FormDetails.appType}/${FormDetails.mem_no}/cert_image.${ext}`;
    setsign1(true);

    const res = await axios.get(
      `${ApiURL}/api/upload/signed-url?key=${encodeURIComponent(key)}&contentType=${encodeURIComponent(file.type)}`
    );
    const { url } = res.data;

    await new Promise((resolve, reject) => {
      const xhr = new XMLHttpRequest();
      xhr.open("PUT", url);
      xhr.setRequestHeader("Content-Type", file.type);

      xhr.upload.onprogress = (event) => {
        if (event.lengthComputable) {
          setProgress3(Math.round((event.loaded / event.total) * 100));
        }
      };

      xhr.onload = () => (xhr.status === 200 ? resolve() : reject(new Error(`Upload failed with status ${xhr.status}`)));
      xhr.onerror = () => reject(new Error("Network error during upload"));

      xhr.send(file);
    });

    setTempDetails({
      ...TempDetails,
      [e.target.name]: `https://pub-5e98b3129b274a77aa3ee9286a182644.r2.dev/${key}`
    });
    setProgress3(0);
    console.log("Cert image uploaded:", key);
  } catch (err) {
    console.error("Upload error (cert):", err);
  }
};

const uploadSign = async (e) => {
  try {
    const file = e.target.files[0];
    if (!file) return;

    const ext = file.name.split('.').pop().toLowerCase();
    if (!["jpg", "jpeg", "bmp", "png"].includes(ext)) {
      alert("Only JPG, BMP, PNG files allowed");
      return;
    }

    const key = `applications/${FormDetails.appType}/${FormDetails.mem_no}/signature_image.${ext}`;
    setsign(true);

    const res = await axios.get(
      `${ApiURL}/api/upload/signed-url?key=${encodeURIComponent(key)}&contentType=${encodeURIComponent(file.type)}`
    );
    const { url } = res.data;

    await new Promise((resolve, reject) => {
      const xhr = new XMLHttpRequest();
      xhr.open("PUT", url);
      xhr.setRequestHeader("Content-Type", file.type);

      xhr.upload.onprogress = (event) => {
        if (event.lengthComputable) {
          setProgress2(Math.round((event.loaded / event.total) * 100));
        }
      };

      xhr.onload = () => (xhr.status === 200 ? resolve() : reject(new Error(`Upload failed with status ${xhr.status}`)));
      xhr.onerror = () => reject(new Error("Network error during upload"));

      xhr.send(file);
    });

    setTempDetails({
      ...TempDetails,
      [e.target.name]: `https://pub-5e98b3129b274a77aa3ee9286a182644.r2.dev/${key}`
    });
    setProgress2(0);
    console.log("Signature image uploaded:", key);
  } catch (err) {
    console.error("Upload error (signature):", err);
  }
};


            const getUpdateUrl = (url)=>{

    console.log("Updating image url 7777777777777777777777777777777777777777");
  
    const oldDomain = "nmobucket.s3.ap-south-1.amazonaws.com";
  const newDomain = "pub-5e98b3129b274a77aa3ee9286a182644.r2.dev";

  return url.replace(oldDomain, newDomain);

  }

    return (
        <>
            {isLoadingMember ? (
                <div style={{ display: 'flex', justifyContent: 'center', padding: '50px' }}>
                    <CircularProgress />
                </div>
            ) : (
                FormDetails._id !== undefined &&

                <div style={{ textAlign: 'center', padding: '0 0 50px 0' }}>
                    <h1>Application Form</h1>
                    <div className="applicationContainer">
                        <div className="applicationFields">
                            <table className="applicationTable">
                                <tr>
                                    <td colSpan="2"><b><u>Profile Details</u></b></td>
                                </tr>
                                <tr style={{ height: '160px' }}>
                                    <td>Profile Image</td>
                                    {
                                        Editable ?
                                            <>
                                                <img src={getUpdateUrl(FormDetails.profile_image)} className="img" style={{ position: 'relative', top: '8px' }} width={125} alt="Profile" />
                                                <input name="profile_image" type="file" onChange={handleFileChange} />
                                                <LinearProgress variant="determinate" value={Progress1} />
                                                <p className="update">{profileE}</p>
                                            </>
                                            :
                                            <>
                                                <td className='td'>
                                                    <img src={getUpdateUrl(FormDetails.profile_image)} className="img " width={125} alt="Profile" />
                                                    <a style={{ position: 'relative', right: '95px', top: '8px' }} href={getUpdateUrl(FormDetails.profile_image)} target="_blank" rel="noreferrer">Click Here to Download</a>
                                                </td>
                                            </>
                                    }
                                </tr>
                                <tr>
                                    <td colSpan="2"><b><u>Doctor Details</u></b></td>
                                </tr>
                                <tr>
                                    <td>Doctor Name</td>
                                    <td>{FormDetails.name}</td>
                                </tr>
                                <tr>
                                    <td>Membership no</td>
                                    <td>{FormDetails.mem_no}</td>
                                </tr>
                                <tr>
                                    <td>Date of Birth (dd/mm/yyyy)</td>
                                    {
                                        Editable ?
                                            <input name="dob" value={TempDetails.dob} onChange={handleChange} type="date" format="dd/MM/yyyy" /> :
                                            <td>{new Date(FormDetails.dob).getDate() + '/' + (new Date(FormDetails.dob).getMonth() + 1) + '/' + new Date(FormDetails.dob).getFullYear()}</td>
                                    }


                                </tr>
                                <tr>
                                    <td>Gender</td>
                                    {
                                        Editable ?
                                            <select name="gender" value={TempDetails.gender} onChange={handleChange}>
                                                {
                                                    gender.map((item, index) => (
                                                        <option key={index} value={item}>{item}</option>
                                                    ))
                                                }
                                            </select> :
                                            <td>{FormDetails.gender}</td>
                                    }

                                </tr>
                                <tr>
                                    <td>Blood Group</td>
                                    {
                                        Editable ?
                                            <select name="blood_group" value={TempDetails.blood_group} onChange={handleChange}>
                                                {
                                                    bloodGroup.map((item, index) => (
                                                        <option key={index} value={item}>{item}</option>
                                                    ))
                                                }
                                            </select> :
                                            <td>{FormDetails.blood_group}</td>
                                    }

                                </tr>
                                <tr>
                                    <td>Phone Number</td>
                                    {
                                        Editable ?
                                            <> <input name="phone" value={TempDetails.phone} onChange={handleChange} type="number" /><p className="update">{phoneE}</p> </> :
                                            <td>{FormDetails.phone}</td>

                                    }
                                    {/* <td>{FormDetails.phone}</td> */}
                                </tr>
                                <tr>
                                    <td>Email Address</td>
                                    {
                                        Editable ?
                                            <><input name="email" value={TempDetails.email} onChange={handleChange} type="email" />  <p className="update">{emailError}</p></> :

                                            <td>{FormDetails.email}</td>
                                    }
                                    {/* <td>{FormDetails.email}</td> */}
                                </tr>

                                <tr>
                                    <td>Signature Image</td>
                                    {
                                        Editable ?
                                            <>
                                                <img src={getUpdateUrl(FormDetails.signature_image)} className="img" style={{ position: 'relative', top: '8px' }} width={125} alt="Signature" />
                                                <input name="signature_image" type="file" onChange={uploadSign} />
                                                <LinearProgress variant="determinate" value={Progress2} />
                                                <p className="update">{profileE}</p>
                                            </>
                                            :
                                            <>
                                                <td style={{ height: '149px' }}>
                                                    <img src={getUpdateUrl(FormDetails.signature_image)} className="img" width={125} alt="Signature" />
                                                    <a style={{ position: 'relative', right: '95px', top: '8px' }} href={getUpdateUrl(FormDetails.signature_image)} target="_blank" rel="noreferrer">Click Here to Download</a>
                                                </td>
                                            </>
                                    }
                                </tr>
                                <tr>
                                    <td colSpan="2"><b><u>Educational Details</u></b></td>
                                </tr>
                                <tr>
                                    <td>Applicant is a</td>
                                    <td>{FormDetails.docstatus.toUpperCase()}</td>
                                </tr>
                                <tr>
                                    <td>Highest Medical Degree</td>
                                    {
                                        Editable ?
                                            <select name="qualifications" value={TempDetails.qualifications} onChange={handleChange}>
                                                {
                                                    FData.qual.map((item, index) => (
                                                        <option key={index} value={item}>{item}</option>
                                                    ))
                                                }
                                            </select> :
                                            <td>{FormDetails.qualifications}</td>
                                    }
                                    {/* 22 oct jyoti added edit button and change we can edit the qualification ----- */}
                                    {/* <td>{FormDetails.qualifications}</td> */}
                                </tr>
                                <tr>
                                    <td>College</td>
                                    {
                                        Editable ?
                                            <div className="ctrl">
                                                <select name="state" value={SName} onChange={stateChanged}>
                                                    {
                                                        stateList.map((item, index) => (
                                                            <option key={index} value={item}>{item}</option>
                                                        ))
                                                    }
                                                </select>
                                                {isTrue ?
                                                    <select name="college" defaultValue={CName} value={CName} onChange={(e) => collegeChanged(e.target.value)}>
                                                        {/* {console.log(collagelist.length,'colllllllege')} */}
                                                        {collagelist.length > 0 ? collagelist.map((item, index) => (
                                                            <option key={index} value={item}>{item}</option>
                                                        )) : <option value={CName}>{CName}</option>}


                                                    </select> : <input name="college" value={TempDetails.college == "other" ? "" : TempDetails.college} placeholder="Enter Your Collage Name" onChange={handleChange} />
                                                }

                                            </div>
                                            :

                                            <td>{FormDetails.college}</td>
                                    }
                                </tr>
                                <tr>
                                    <td>Medical License / College Reg No</td>
                                    {
                                        Editable ?
                                            <>
                                                <input name="regno" value={TempDetails.regno} onChange={handleChange} />
                                                <p className="update">{RegE}</p>
                                            </> :
                                            <td>{FormDetails.regno}</td>
                                    }
                                    {/* 22 oct jyoti edit  */}

                                    {/* <td>{FormDetails.regno}</td> */}
                                </tr>
                                <tr>
                                    <td>Medical License / College ID</td>
                                    {
                                        Editable ?
                                            <>
                                                <input name="cert_image" type="file" onChange={handleIdChange} />
                                                <LinearProgress variant="determinate" value={Progress3} />
                                                <p className="update">{medError}</p>
                                            </> :
                                            // <td>
                                            // <button className="btn btn-primary" onClick={() => {FormDetails.cert_image}}>View</button>
                                            // </td>

                                            <td><a href={getUpdateUrl(FormDetails.cert_image)} target="_blank" rel="noreferrer">Click Here to View</a></td>
                                    }
                                    {/* <td><a href={FormDetails.cert_image} target="_blank" rel="noreferrer">Click Here to View</a></td> */}
                                </tr>


                                <tr>
                                    <td><b><u>Correspondence Address</u></b></td>
                                    {
                                        Editable ?
                                            <td>
                                                <input placeholder="Address *" name="line1" value={TempDetails.address.line1} onChange={handleAddChange} />
                                                {/* <input name="line2" value={TempDetails.address.line2} onChange={handleAddChange}/> */}
                                                <select placeholder="State *" name="state" value={TempDetails.address.state} onChange={handleAddChange}>
                                                    {
                                                        FData.states.map((item, index) => (
                                                            <option key={index} value={item.state}>{item.state}</option>
                                                        ))
                                                    }
                                                </select>
                                                <select placeholder="City *" name="city" value={TempDetails.address.city} onChange={handleAddChange}>
                                                    {
                                                        TempCList.map((item, index) => (
                                                            <option key={index} value={item}>{item}</option>
                                                        ))
                                                    }
                                                </select>
                                                <input name="pincode" value={TempDetails.address.pincode} onChange={handleAddChange} />
                                            </td> :
                                            <td>
                                                {FormDetails.address.line1}<br />
                                                {/* {FormDetails.address.line2}<br/> */}
                                                {FormDetails.address.city}, {FormDetails.address.state}<br />
                                                {FormDetails.address.pincode}
                                            </td>
                                    }

                                </tr>
                                <tr>
                                    <td colSpan="2"><b><u>Association with NMO</u></b></td>
                                </tr>
                                <tr>
                                    <td>NMO State</td>
                                    {
                                        Editable ?
                                            <select name="nmo_state" value={TempDetails.nmo_state} onChange={handelNmoState}>
                                                {
                                                    nmoLists.map((item, index) => (
                                                        <option key={index} value={item}>{item}</option>
                                                    ))
                                                }
                                            </select> :
                                            <td>{FormDetails.nmo_state}</td>
                                    }
                                    {/* <td>{FormDetails.nmo_state}</td> */}
                                </tr>
                                <tr>
                                    <td>NMO Prant</td>
                                    {
                                        Editable ?
                                            <select name="prant" value={TempDetails.prant} onChange={handelNmoPrant}>
                                                <option value=''></option>
                                                {
                                                    nmoPrant.map((item, index) => (
                                                        <option key={index} value={item}>{item}</option>
                                                    ))
                                                }
                                            </select> :
                                            <td>{FormDetails.prant}</td>
                                    }

                                </tr>
                                <tr>
                                    <td>NMO unit</td>
                                    {
                                        Editable ?
                                            <td>
                                                <input name="nmo_unit" value={TempDetails.nmo_unit} onChange={handleChange} type="text" />
                                            </td> :
                                            <td>{FormDetails.nmo_unit}</td>
                                    }
                                    {/* <td>{FormDetails.nmo_unit}</td> */}
                                </tr>
                                <tr>
                                    <td>NMO State Secretary Email</td>
                                    {
                                        Editable ?
                                            <td>
                                                <input name="state_sec_email" value={TempDetails.state_sec_email} onChange={handleChange} type="text" />
                                                <p className="update">{secEmailError}</p>
                                            </td> :
                                            <td>{FormDetails.state_sec_email}</td>
                                    }
                                    {/* <td>{FormDetails.state_sec_email}</td> */}
                                </tr>
                                <tr>
                                    <td>Referrer/Contact Person Name</td>
                                    {
                                        Editable ?
                                            <td>
                                                <input placeholder="Referrer Person Name" name="ref_person" value={TempDetails.ref_person} onChange={handleChange} type="text" />
                                                <p className="update">{RefnameE}</p>
                                            </td> :
                                            <td>{FormDetails.ref_person}</td>
                                    }
                                    {/* <td>{FormDetails.ref_person}</td> */}
                                </tr>
                                <tr>
                                    <td>Referrer/Contact Person Phone</td>
                                    {
                                        Editable ?
                                            <td>
                                                <input name="ref_person_phone" value={TempDetails.ref_person_phone} onChange={handleChange} type="text" />
                                                <p className="update">{secphoneE}</p>
                                            </td> :
                                            <td>{FormDetails.ref_person_phone}</td>
                                    }
                                    {/* <td>{FormDetails.ref_person_phone}</td> */}
                                </tr>
                                <tr>
                                    <td>Referrer/Contact Person NMO Membership Number</td>
                                    {
                                        Editable ?
                                            <td>
                                                <input name="ref_membership_no" value={TempDetails.ref_membership_no} onChange={handleChange} type="text" />
                                                <p className="update">{RefMemN}</p>
                                            </td> :
                                            <td>{FormDetails.ref_membership_no}</td>
                                    }
                                    {/* <td>{FormDetails.ref_membership_no}</td> */}
                                </tr>
                                <tr>
                                    <td>Verification</td>
                                    {/* 21 oct jyoti 
                            added verified button */}
                                    <td>{!FormDetails.payment.success ? "Not Verified" : ((FormDetails.isVerified === false && FormDetails.payment.success === true) ? <Button variant="contained" color="primary" onClick={handleverify} disabled={Editable}>Verify</Button> : "Verified")}</td>



                                </tr>
                                {
                                    FormDetails.appApproved ?
                                        <>
                                            <tr>
                                                <td colSpan="2"><b><u>Member Documents</u></b></td>
                                            </tr>
                                            <tr>
                                                <td>Certificate Image</td>
                                                <td>
                                                    <a href={getUpdateUrl(FormDetails.mem_cert_image)} target="_blank" rel="noreferrer">Click Here to View</a></td>
                                            </tr>
                                            <tr>
                                                <td>ID Card Image</td>
                                                <td>
                                                    <a href={getUpdateUrl(FormDetails.mem_idCard_image)} target="_blank" rel="noreferrer">Click Here to View</a>
                                                </td>
                                            </tr>
                                        </>
                                        :
                                        <tr>
                                            <td><Button variant="contained" color="primary" onClick={handleApprove} disabled={Editable || !FormDetails.isVerified || loginRes === "Employee"}>Approve</Button></td>
                                            <td><Button variant="contained" color="secondary" onClick={handleReject} disabled={Editable || !FormDetails.isVerified || loginRes === "Employee"}>Reject</Button></td>

                                            {/* 20 oct jyoti change Approve and reject button */}

                                        </tr>
                                }
                                <tr>
                                    <td>{!FormDetails.payment.success && FormDetails.payment.mode === 'Online' ? <Button variant="contained" color="secondary" onClick={() => setIsOpen5(true)} disabled={Editable || FormDetails.payment.success}>Delete Application</Button> : ""}</td>

                                </tr>
                                <tr>
                                    <td>
                                        <Button variant="contained" color={Editable ? "secondary" : 'primary'} onClick={handleEdit}>{Editable ? "Cancel" : "Edit"}</Button>
                                    </td>
                                    {Editable ? <td>
                                        {Editable && <Button variant="contained" color='primary' onClick={handleUpdate}>Update</Button>}
                                    </td> : <td>
                                        <Button variant="contained" color="secondary" onClick={handleApprove} disabled={Editable} >ReGenerate ID Card & Certificate</Button>
                                    </td>}


                                </tr>

                            </table>
                        </div>

                    </div>
                    <div>

                        <canvas ref={canvas} width={1280} height={973} className="hidden" />
                        <img ref={image} src={cert} className="hidden" alt="testbed" />
                        <canvas ref={canvas4} width={1280} height={940} className="hidden" />
                        <img ref={image4} src={studentCert} className="hidden" alt="testbed" />

                    </div>
                    <div>
                  
                        <canvas ref={canvas1} width={1240} height={1700} className="hidden" />
                        <img ref={image1} src={welen} alt="testbed" className="hidden" />
                        <canvas ref={canvas0} width={1240} height={1700}className="hidden" />
                        <img ref={image0} src={stwelen} alt="testbed" className="hidden" />
                    </div>
                    <div>
                        <canvas ref={canvas2} width={1240} height={1700} className="hidden" />
                        <img ref={image2} src={welhi} alt="testbed" className="hidden" />
                        <canvas ref={canvas7} width={2481} height={3509} className="hidden" />
                        <img ref={image7} src={stwelhi} alt="testbed" className="hidden" />
                    </div>
                    <div>
                        <canvas ref={canvas3} width={635} height={931} className="hidden" />
                        <img ref={image3} src={idcard} alt="testbed" className="hidden" />
                        <canvas ref={canvas5} width={620} height={930} className="hidden" />
                        <img ref={image5} src={studentId} alt="testbed" className="hidden" />
                        {/* <canvas ref={canvas3} width={872} height={1280} className="hidden" />
                        <img ref={image3} src={idcard} alt="testbed" className="hidden" />
                        <canvas ref={canvas5} width={620} height={890} className="hidden" />
                        <img ref={image5} src={studentId} alt="testbed" className="hidden" /> */}
                        {/* <img ref={image4} src={FormDetails.profile_image}  alt="testbed" className="hidden"/> */}
                    </div>
                </div>
            )}
            <Dialog open={IsOpen7} >
                <DialogTitle >{"Approve Application?"}</DialogTitle>
                <DialogContent>
                    <DialogContentText id="alert-dialog-description">
                        Are you sure, you want to Re Generate Certificate?
                    </DialogContentText>
                </DialogContent>
                <DialogActions>
                    <Button onClick={handleSubApp} color="primary">
                        Yes
                    </Button>
                    <Button onClick={handleNoApp} color="secondary">
                        No
                    </Button>
                </DialogActions>
            </Dialog>
            <Dialog fullScreen open={Open} onClose={handleClose}>
                <div style={{ display: 'flex', justifyContent: 'space-between', padding: '10px 30px' }}>
                    <h3>Re Generate Certificate</h3>
                    <Button variant="contained" onClick={handleClose} disabled={isSubmitting} color="secondary">Close</Button>
                </div>
                <div style={{ display: 'flex', justifyContent: 'space-evenly', padding: '10px, 30px' }}>

                    {FormDetails.appType !== 'student' ?
                        <img src={TempImg} alt='temp' width={600} height={480} /> :
                        <img src={TempImg2} alt='temp' width={600} height={480} />}
                    {FormDetails.appType !== 'student' ?
                        <img src={TempIdCard} alt='temp' width={410} height={600} /> :
                        <img src={TempIdCards} alt='temp' width={410} height={600} />}

                    <div >
                        {FormDetails.appType !== 'student' ?
                            <div >
                                <h4>Update Membership Certificate (optional)</h4>
                                <TextField value={TempName} label="Update Doctor Name" onChange={handleTempName} />
                                <TextField value={TempQul} label="Update Doctor Qualification" onChange={handleTempQul} />
                                {/* <Button variant="contained" color="primary" disabled={isSubmitting} onClick={() => generateCert(MemNo.toString(), TempName, TempQul,FormDetails.college, FormDetails.nmo_unit, FormDetails.email, FormDetails.blood_group, `${FormDetails.address.line1} , ${FormDetails.address.line2}`, FormDetails.phone,`${FormDetails.address.city} , ${FormDetails.address.state} , ${FormDetails.address.pincode}`,  true)}>Update</Button> */}
                                <TextField value={TempIssuDate} type="text" label="Update Issu Date" onChange={handleTempIssuDate} />
                                <Button variant="contained" color="primary" disabled={isSubmitting} onClick={() => generateCert(MemNo.toString(), TempName, TempQul, FormDetails.college, FormDetails.nmo_unit, FormDetails.email, FormDetails.blood_group, `${FormDetails.address.line1} , ${FormDetails.address.line2}`, FormDetails.phone)}>Update</Button>
                            </div> : <div>
                                <h4>Update Membership Certificate (optional)</h4>
                                <TextField value={TempName} label="Update Student Name" onChange={handleTempName} />
                                <TextField value={TempQul} label="Update Student Qualification" onChange={handleTempQul} />
                                <TextField value={TempCour} label="Update Student College" onChange={handleTempCour} />
                                <TextField value={TempIssuDate} type="text" label="Update Issu Date" onChange={handleTempIssuDate} />
                                <Button variant="contained" color="primary" disabled={isSubmitting} onClick={() => generateCert(MemNo.toString(), TempName, TempQul, TempCour, FormDetails.nmo_unit, FormDetails.email, FormDetails.blood_group, `${FormDetails.address.line1} , ${FormDetails.address.line2}`, FormDetails.phone, `${FormDetails.address.city} , ${FormDetails.address.state} , ${FormDetails.address.pincode}`, true)}>Update</Button>

                            </div>}
                    </div>
                </div>

                <div style={{ display: 'flex', flexDirection: 'column', justifyContent: 'center', alignItems: 'center', padding: '10px, 30px' }}>
                    <Button variant="contained" disabled={isSubmitting} color="primary" onClick={handleopen}>Save and Send</Button>
                    {isSubmitting &&
                        <CircularProgress />
                    }
                </div>
            </Dialog>
            <Dialog fullScreen open={Open1} onClose={handleClose}>
                <div style={{ display: 'flex', justifyContent: 'space-between', padding: '10px 30px' }}>
                    <h3>Finalize Application Rejection</h3>
                    <Button variant="contained" onClick={handleClose} color="secondary">Close</Button>
                </div>
                <div style={{ display: 'flex', justifyContent: 'space-evenly', padding: '10px, 30px' }}>
                    <div style={{ maxWidth: '500px' }}>
                        <h4>Email Sample</h4>
                        <p>
                            {`This is regarding your membership application at National Medicos Organization.`}
                            <br />
                            {`Please provide following information in the given format:`}
                            <br />
                            <br />
                            {TempReason}
                            <br />
                            <br />
                            {`Vande Mataram!`}
                            <br />
                            {`Bharat Mata ki Jai`}
                        </p>
                    </div>
                    <div>
                        <h4>Provide Reason for Rejection</h4>
                        <textarea minRows={4} value={TempReason} placeholder="Type here" onChange={handleTempReason} />
                    </div>
                </div>
                <div style={{ display: 'flex', justifyContent: 'center', padding: '10px, 30px' }}>
                    <Button variant="contained" disabled={TempReason.length === 0} color="primary" onClick={handleFinalReject}>Click Here to Reject Application</Button>
                </div>
            </Dialog>
            <Dialog open={IsOpen1} >
                <DialogTitle >{"Approve Application?"}</DialogTitle>
                <DialogContent>
                    <DialogContentText id="alert-dialog-description">
                        Are you sure, you want to Verify application?
                    </DialogContentText>
                </DialogContent>
                <DialogActions>
                    <Button onClick={handleSubApp} color="primary">
                        Yes
                    </Button>
                    <Button onClick={handleNoApp} color="secondary">
                        No
                    </Button>
                </DialogActions>
            </Dialog>
            <Dialog fullScreen open={IsOpen6} onClose={handleClose}>
                <div style={{ display: 'flex', justifyContent: 'space-between', padding: '10px 30px' }}>
                    <h3>Update Member Verification</h3>
                    <Button variant="contained" onClick={handleClose} disabled={isSubmitting} color="secondary">Close</Button>
                </div>
                <div style={{ display: 'flex', justifyContent: 'space-evenly', padding: '10px, 30px' }}>

                    {FormDetails.appType !== 'student' ?
                        <img src={TempImg} alt='temp' width={600} height={480} /> :
                        <img src={TempImg2} alt='temp' width={600} height={480} />}
                    {FormDetails.appType !== 'student' ?
                        <img src={TempIdCard} alt='temp' width={410} height={600} /> :
                        <img src={TempIdCards} alt='temp' width={410} height={600} />}

                    {FormDetails.appType !== 'student' ? <div>
                        <h4>Update Membership Certificate (optional)</h4>
                        <TextField value={TempName} label="Update Doctor Name" onChange={handleTempName} />
                        <TextField value={TempQul} label="Update Doctor Qualification" onChange={handleTempQul} />
                        {/* <TextField value={TempIssuDate} label="Update Issu Date" onChange={handleTempIssuDate} /> */}
                        <Button variant="contained" color="primary" disabled={isSubmitting} onClick={() => generateCert(MemNo.toString(), TempName, TempQul, FormDetails.college, FormDetails.nmo_unit, FormDetails.phone, FormDetails.email, FormDetails.blood_group, `${FormDetails.address.line1} , ${FormDetails.address.line2}`, `${FormDetails.address.city} , ${FormDetails.address.state} , ${FormDetails.address.pincode}`, FormDetails.profile_image, FormDetails.signature_image, true)}>Update</Button>

                    </div> : <div>
                        <h4>Update Membership Certificate (optional)</h4>
                        <TextField value={TempName} label="Update Student Name" onChange={handleTempName} />
                        <TextField value={TempQul} label="Update Student Qualification" onChange={handleTempQul} />
                        <TextField value={TempCour} label="Update Student College" onChange={handleTempCour} />
                        {/* <TextField value={TempIssuDate} label="Update Issu Date" onChange={handleTempIssuDate} /> */}
                        <Button variant="contained" color="primary" disabled={isSubmitting} onClick={() => generateCert(MemNo.toString(), TempName, TempQul, TempCour, FormDetails.nmo_unit, FormDetails.phone, FormDetails.email, FormDetails.blood_group, `${FormDetails.address.line1} , ${FormDetails.address.line2}`, `${FormDetails.address.city} , ${FormDetails.address.state} , ${FormDetails.address.pincode}`, true)}>Update</Button>

                    </div>}
                </div>

                <div style={{ display: 'flex', flexDirection: 'column', justifyContent: 'center', alignItems: 'center', padding: '10px, 30px' }}>
                    <Button variant="contained" disabled={isSubmitting} color="primary" onClick={handleFinalApproval}>Click Here to Final Verify</Button>
                    {isSubmitting &&
                        <CircularProgress />
                    }
                </div>

            </Dialog>
            <Dialog open={IsOpen4} >
                <DialogTitle >{"Check Payment Status"}</DialogTitle>
                <DialogContent>
                    <DialogContentText id="alert-dialog-description">
                        Payment for this application has some errors, please check with payment service provider.
                    </DialogContentText>
                </DialogContent>
                <DialogActions>
                    <Button onClick={() => setIsOpen4(false)} color="primary">
                        OK
                    </Button>
                </DialogActions>
            </Dialog>
        </>
    )
}

export default AdminStudentsView

